import { EditIcon, DeleteIcon } from '@chakra-ui/icons';

export const columnsDataColors = [
  {
    Header: "Id",
    accessor: "id",
  },
  {
    Header: "Código de color",
    accessor: "name",
  },
  {
    Header: '',
    accessor: 'actions',
    actions: [
      {
        label: 'Editar',
        icon: <EditIcon />,
        colorScheme: 'blue',
        type: 'edit'
      },
      {
        label: 'Eliminar',
        icon: <DeleteIcon />,
        colorScheme: 'red',
        type: 'delete'
      },
    ]
  }
  
];
